import { render, staticRenderFns } from "./ToggleTitle.vue?vue&type=template&id=2f7a85c8&scoped=true"
import script from "./ToggleTitle.vue?vue&type=script&lang=js"
export * from "./ToggleTitle.vue?vue&type=script&lang=js"
import style0 from "./ToggleTitle.vue?vue&type=style&index=0&id=2f7a85c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a85c8",
  null
  
)

export default component.exports